import '../sass/screen.scss'; // Import SASS for processing

jQuery(document).ready(function($) {



    $('#nav-toggle').click(function(){
        $('body').toggleClass('m-toggle');
    });   


    // -- faq accordion

    $('.faq header').click(function(){
        $(this).parent().toggleClass('active');
    });

  

    // -- header height
    const header = document.querySelector('.header');

    const getHeaderHeight = () => {

        // -- set timeout to allow for the header to render
        setTimeout(function() { 
        
            let headerHeight = header.offsetHeight;
    
            document.documentElement.style.setProperty('--header-height', (headerHeight - 18) + 'px');
    
        }, 500);
    
    };

    getHeaderHeight();

    // -- resize event
    window.addEventListener('resize', getHeaderHeight);


    var $slider, $slider2;

 
    if ( $('.product__slider-main').length ) {

        var slider_dom = $('.product__slider-main');
        var slider_dom2 = $('.product__slider-thmb');

    

        if( slider_dom2.length ) {
         
             $slider = $('.product__slider-main')
                .slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    autoplay: false,
                    autoplaySpeed: 3000,
                    asNavFor: '.product__slider-thmb',
                    prevArrow: '<button class="slick-arrow prev"><i class="fas fa-chevron-left"></i></button>',
                    nextArrow: '<button  class="slick-arrow next"><i class="fas fa-chevron-right"></i></button>'
                });
        } else {
          
             $slider = $('.product__slider-main')
                .slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    autoplay: false,
                    autoplaySpeed: 3000,
                    prevArrow: '<button class="slick-arrow prev"><i class="fas fa-chevron-left"></i></button>',
                    nextArrow: '<button  class="slick-arrow next"><i class="fas fa-chevron-right"></i></button>'
                });

        }

        
        if( slider_dom2.length ) {

                alert( 'yes' );

                 $slider2 = $('.product__slider-thmb')
                    .slick({
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        asNavFor: '.product__slider-main',
                        dots: false,
                        centerMode: false,
                        focusOnSelect: true,
                        infinite: true,
                        prevArrow: '<button class="slick-arrow prev"><i class="fas fa-chevron-left"></i></button>',
                        nextArrow: '<button  class="slick-arrow next"><i class="fas fa-chevron-right"></i></button>',
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 5,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    });

                }
            
        }


        // -- Toggle our panels UI 
        

        var options_nav = $('.options--withnav');
        var options_links = $('nav ul a', options_nav);
        var options_panels = $('.options-content > div');

        if( options_nav.length ) {

                options_links.click(function(e) {
                    e.preventDefault();
                    var target = $(this).attr('href');
                    // -- now find id in options panels and hide the others
                    // -- remove hash from target
                    var target_id = target.replace('#', '');
                    options_panels.each(function() {
                    
                    


                        if ($(this).attr('id') == target_id) { 
                            $(this).addClass('active');
                        }
                        else {
                            $(this).removeClass('active');
                        }
                    });
                    // -- now find the link and add the active class
                    options_links.each(function() {
                        if ($(this).attr('href') == target) {
                            $(this).addClass('active');
                        }
                        else {
                            $(this).removeClass('active');
                        }
                    }
                    );
                });

                // -- now find the first link and click it
                options_links.first().click();

        }


        // -- if .masthead__images has more than 1 img then we need to fade them in and out ( they are already positioned with CSS )

        var masthead_images = $('.masthead__images img');

        if( masthead_images.length > 1 ) {

            // -- set the first image to be visible
            masthead_images.first().addClass('visible');
            // -- set the rest to be hidden
            masthead_images.not(':first').addClass('hidden');
            
            // -- set a timer to fade them in and out
            setInterval(function() {
                // -- find the first image that is visible
                var current = masthead_images.filter('.visible');
                // -- find the next image
                var next = current.next('img');
                // -- if there is no next then go to the first one
                if( next.length == 0 ) {
                    next = masthead_images.first();
                }
                // -- fade out the current image
                current.removeClass('visible').addClass('hidden');
                // -- fade in the next image
                next.removeClass('hidden').addClass('visible');
            }, 5000);
            
        }




     


     // -- set timeout to allow for the google maps api to load
    setTimeout(function() { 

      initMap();

    }, 1000);

    function initMap() {

  

      // -- look for #map its long is data attribute "data-lng" and its lat is data attribute "data-lat" and make a google map with a marker
     
       if($('#map').length) {
   
           var lat = $('#map').attr('data-lat');
           var lng = $('#map').attr('data-lng');
   
           var myLatLng = {lat: parseFloat(lat), lng: parseFloat(lng)};

           // creae a new map and use the custom style
            const map = new google.maps.Map(document.getElementById('map'), {
                zoom: 16,
                center: myLatLng,
                styles: mapStyle
            });
   
        
   
           const marker = new google.maps.Marker({
               position: myLatLng,
               map: map
           });
   
       } else {
         console.error("#map not found in the DOM.");
       }
   
   }


  const stickyElement = document.querySelector('.page-anchors--about');

  const viewportHeight = window.innerHeight;

  console.log( stickyElement );

  if( stickyElement ) {

    // -- work out on scroll where we are

    window.addEventListener('scroll', function() {

      let scrollY = window.scrollY;

      console.log( scrollY + ' ' + (viewportHeight/2) );

      if(scrollY > viewportHeight) {
        stickyElement.classList.add('stuck');
      } else {
        
        stickyElement.classList.remove('stuck');
      }

    });
  }



})


var mapStyle = [
  {
      "featureType": "all",
      "elementType": "labels",
      "stylers": [
          {
              "visibility": "on"
          }
      ]
  },
  {
      "featureType": "all",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "saturation": 36
          },
          {
              "color": "#000000"
          },
          {
              "lightness": 40
          }
      ]
  },
  {
      "featureType": "all",
      "elementType": "labels.text.stroke",
      "stylers": [
          {
              "visibility": "on"
          },
          {
              "color": "#000000"
          },
          {
              "lightness": 16
          }
      ]
  },
  {
      "featureType": "all",
      "elementType": "labels.icon",
      "stylers": [
          {
              "visibility": "off"
          }
      ]
  },
  {
      "featureType": "administrative",
      "elementType": "geometry.fill",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 20
          }
      ]
  },
  {
      "featureType": "administrative",
      "elementType": "geometry.stroke",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 17
          },
          {
              "weight": 1.2
          }
      ]
  },
  {
      "featureType": "administrative.country",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#ed5929"
          }
      ]
  },
  {
      "featureType": "administrative.locality",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#c4c4c4"
          }
      ]
  },
  {
      "featureType": "administrative.neighborhood",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#ffcb05"
          }
      ]
  },
  {
      "featureType": "landscape",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 20
          }
      ]
  },
  {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 21
          },
          {
              "visibility": "on"
          }
      ]
  },
  {
      "featureType": "poi.business",
      "elementType": "geometry",
      "stylers": [
          {
              "visibility": "on"
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [
          {
              "color": "#ffcb05"
          },
          {
              "lightness": "0"
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
          {
              "visibility": "off"
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#000000"
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "labels.text.stroke",
      "stylers": [
          {
              "color": "#ed5929"
          },
          {
              "visibility": "off"
          }
      ]
  },
  {
      "featureType": "road.arterial",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 18
          }
      ]
  },
  {
      "featureType": "road.arterial",
      "elementType": "geometry.fill",
      "stylers": [
          {
              "color": "#ffcb05"
          }
      ]
  },
  {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#000000"
          }
      ]
  },
  {
      "featureType": "road.arterial",
      "elementType": "labels.text.stroke",
      "stylers": [
          {
              "color": "#ffffff"
          },
          {
              "visibility": "off"
          }
      ]
  },
  {
      "featureType": "road.local",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 16
          }
      ]
  },
  {
      "featureType": "road.local",
      "elementType": "geometry.fill",
      "stylers": [
          {
              "color": "#666666"
          }
      ]
  },
  {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#ffffff"
          }
      ]
  },
  {
      "featureType": "transit",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 19
          }
      ]
  },
  {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 17
          }
      ]
  }
];




document.addEventListener('DOMContentLoaded', function () {

    let currentDepth = 0;
    let hasSetup = false;

    function initNav() {

        // -- are we less than 1301px
        if( window.innerWidth > 1300 ) return;


        if (hasSetup) return;
        console.log( "init Nav" );
        setUpBackButtons();
        setUpClickHandlers();
        hasSetup = true;
    }

    const setUpClickHandlers = () => {
        let hasChild = document.querySelectorAll('.menu-item-has-children > a');

        hasChild.forEach(function (item) {
            item.addEventListener('click', function (event) {
                console.log('clicked');
                event.preventDefault();

                let parent = this.parentElement;
                let sub = parent.querySelector('.sub-menu');

                console.log(sub);
                sub.classList.add('active');
            });
        });
    };

    const setUpBackButtons = () => {
        let subs = document.querySelectorAll('.menu-item-has-children ul');

        subs.forEach(function (item) {

        
            let back = document.createElement('li');
            back.classList.add('back');
            back.innerHTML = '<button class="back"><i class="bx bx-chevron-left"></i> Back</button>';
            item.insertBefore(back, item.firstChild);

            
            back.addEventListener('click', function (event) {
                event.preventDefault();
                this.parentElement.classList.remove('active');
            });
        });
    };

    if (window.innerWidth < 1300) {
        initNav();
    }

    // -- need a resize event to check if we need to re-init the nav
    window.addEventListener('resize', function () {
        if (window.innerWidth < 1300 && !hasSetup) {
            initNav();
        }
    });



});


// -- [GLOBAL] on reszie get the header height and set it as a css var



const getHeaderHeight = () => {

    const header = document.querySelector('.header');

    // -- set timeout to allow for the header to render

    setTimeout(function() { 
    
        let headerHeight = header.offsetHeight;

        document.documentElement.style.setProperty('--header-height', (headerHeight - 18) + 'px');

    }, 1000);

};

document.addEventListener('DOMContentLoaded', function() {

    // -- add a JS class to the body
    document.body.classList.add('js');

    // -- get the header height and assign it as a VAR
    getHeaderHeight();

    window.addEventListener('resize', function() {
            
            getHeaderHeight();
    
    });

});